import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import RedirectPage from "./components/redirect/RedirectPage";
import PrivacyPolicy from "./components/privacyPolicy/PrivacyPolicy";
import Contact from "./components/contact/Contact";
import Features from "./components/features/Features";
import Home from "./components/home/Home";
import FAQ from "./components/faq/FAQ";
import Header from "./components/header/Header";
import VideoPlayer from "./components/videoWatch/VideoPlayer";
import AccountDeletionRequest from "./components/accountDeletion/AccountDeletion";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" exact element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/video/:id" element={<VideoPlayer/>}/>
        <Route path="/contact" element={<Contact />} />
        <Route path="/redirect" element={<RedirectPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/delete-account" element={<AccountDeletionRequest/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
